import "./OverOns.module.css";
import Header from "@/reusable_sections/Header";
import OurJourneySince2010 from "./sections/OurJourneySince2010";
import HetTeamVanProfessionals from "./sections/HetTeamVanProfessionals";
import Footer from "@/reusable_sections/Footer";
export default function OverOnsPage() {
  return <div>
      <Header />
      <OurJourneySince2010 />
      <HetTeamVanProfessionals />
      <Footer />
    </div>;
}